<div class="pt-table-filter" *ngIf="firstLoadingCompleted">
  <div class="filter-input">
    <pt-icon class='filter-icon' [key]='IconSearch'></pt-icon>
    <ng-select
      #select
      content="body"
      [id]="filterId"
      [addTag]="addTag"
      [multiple]="true"
      [clearable]="true"
      [searchable]="true"
      class="filter-select"
      [items]="currentItems"
      dropdownPosition="bottom"
      [disabled]="!enabledSearch"
      [(ngModel)]="selectedValue"
      [searchFn]="customSearchFn"
      [notFoundText]="addTag ? ('PLACEHOLDERS.ADD_FILTER' | translate) : 'Select'"
      placeholder="{{enabledSearch ? undefined : ('PLACEHOLDERS.NO_FILTER_AVAILABLE' | translate)}}"
      (clear)="reset()"
      (keydown.enter)="keydownEnter();"
      (keydown.backspace)="keydownBackspace()"
      (ngModelChange)="log(2);changeModels($event)" (remove)="onRemoveItem($event)">

      <ng-template ng-header-tmp *ngIf="enabledDate()">
        <ngb-datepicker
          [(ngModel)]="model"
          *ngIf="renderDataPicker"
          (dateSelect)="onDateSelect($event)"
          (navigate)="onDateNavigate($event)"
        />
      </ng-template>

      <ng-template ng-header-tmp *ngIf="enabledBoolean()">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="onBooleanSelect(true)">
            {{ 'LABELS.TRUE' | translate }}
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="onBooleanSelect(false)">
            {{ 'LABELS.FALSE' | translate }}
          </button>
        </div>

        <!--        <ngb-datepicker-->
        <!--          [(ngModel)]="model"-->
        <!--          *ngIf="renderDataPicker"-->
        <!--          (dateSelect)="onDateSelect($event)"-->
        <!--          (navigate)="onDateNavigate($event)"-->
        <!--        />-->
      </ng-template>

      <ng-template ng-tag-tmp let-search="searchTerm">
          <span *ngIf="search?.length > 0">
            {{ 'PLACEHOLDERS.PRESS_ENTER_TO_ADD_FILTER' | translate }}: <b>{{ search }}</b>
          </span>
        <span *ngIf="!(search?.length > 0)">
            {{ 'PLACEHOLDERS.ADD_FILTER' | translate }}
          </span>
      </ng-template>

      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div class="d-flex align-items-center" *ngFor="let item of items;  index as i ">
          <div class="ng-value">
            <span class="ng-value-label"
                  [class.ng-value-column]="item.type === 'column'"
                  [class.ng-value-operator]="item.type === 'operator'"
                  [class.ng-value-value]="item.type === 'value'">
              <span *ngIf="item.type === 'column'">{{ item.value }}</span>
              <span *ngIf="item.type === 'operator'">{{ QS.mappingLabel(item.value) | translate }}</span>
              <span *ngIf="item.type === 'value'">
                <span [ngSwitch]="(items[i - 1]).columnType">
                  <ng-container *ngSwitchCase="'BOOLEAN'">
                    <span *ngIf="item.value === 'true'">{{ 'LABELS.TRUE' | translate | uppercase }}</span>
                    <span *ngIf="item.value === 'false'">{{ 'LABELS.FALSE' | translate | uppercase }}</span>
                  </ng-container>
                  <ng-container *ngSwitchDefault>{{ item.value }}</ng-container>
                </span>

              </span>
            </span>
            <span aria-hidden="true" class="ng-value-icon right" *ngIf="item.type === 'value'"
                  (click)="i === items.length - 1 ? clear(item) : clearItem(item, i)">×</span>
          </div>
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <span *ngIf="item.type === 'operator'">{{ QS.mappingLabel(item.value) | translate }}</span>
        <span *ngIf="item.type !== 'operator'">{{ item.value }}</span>
      </ng-template>
    </ng-select>
  </div>

  <button class="btn btn-link btn-sm filter-button d-flex align-items-center text-secondary"
          *ngIf="showReindex"
          [disabled]="disabledSearch || reindexRunning"
          (click)='settings.emit()'>
    <!--    {{ 'BUTTON.REINDEX' | translate }}-->
    <pt-icon [key]="IconSettings"></pt-icon>
  </button>
</div>
